import React from 'react';
import { Box } from '@mui/material';

import {formattaValuta} from '../../utilities/formatNumber.js';




const ResultsIntroList = ({ estimatorData, quotationResults }) => {

  let finalita = '';
  switch (estimatorData?.finalita) {
    case 'Acquistoprimacasa':
      finalita = 'acquisto prima casa';
      break;
    case 'Acquistosecondacasa':
      finalita = 'acquisto seconda casa';
      break;
    case 'Acquisto+Sostituzione':
      finalita = 'acquisto + liquidità';
      break;
    case 'Acquisto+Ristrutturazione':
      finalita = 'acquisto + ristrutturazione';
      break;
    case 'Surroga':
      finalita = 'surroga';
      break;
    default:
      finalita = 'acquisto prima casa';
      break;
  }

  return (
    <div>
      <div className="onlydesktop" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <h5 style={{ margin: '0 0 10px 0' }}>{`Offerte mutuo casa da ${formattaValuta(estimatorData?.importo, '', '.', 0)}€`}</h5>
        <h5 style={{ margin: '0 0 10px 0' }}>{`Aggiornate al ${new Date().toLocaleDateString()}`}</h5>
      </div>
      <Box className="introResults" sx={{ width: '100%' }}>
        <div className='arrowContent'></div>
        <h2>{`Confronta i mutui da ${formattaValuta(estimatorData?.importo, '', '.', 0)}€ e trova la rata più conveniente`}</h2>
        <ul>
          <li>{'Personalizza i dati del modulo e clicca su “Aggiorna ricerca“'}</li>
          <li>{`Scopri tutte le offerte di mutuo da ${formattaValuta(estimatorData?.importo, '', '.', 0)} euro disponibili`}</li>
          <li>{'Scegli la proposta migliore e richiedi la fattibilità online'}</li>
        </ul>
        {quotationResults && quotationResults.length > 0 && (
          <div>
            <h3>{`Offerte di mutuo ${quotationResults[0].durata} anni a tasso ${quotationResults[0].tipotasso.toLowerCase()}`}</h3>
            <p>{`Mutuo di € ${formattaValuta(estimatorData?.importo, '', '.', 0)} per ${finalita}, TAN a partire da ${
              quotationResults[0].tan
            }%, TAEG a partire da ${quotationResults[0].taeg}%, rata mensile da € ${quotationResults[0].rata}`}</p>
          </div>
        )}
      </Box>
    </div>
  );
};

export default ResultsIntroList;
